import { Price } from '@/domain/stripe/customer/sub-domains/subscription/model/Price'
import { Product } from '@/domain/stripe/customer/sub-domains/subscription/model/Product'

export class SubscriptionItem {
  constructor(
    public readonly id: string,
    public readonly quantity: number,
    public readonly product?: Product,
    public readonly price?: Price,
  ) {
  }

  public get totalPrice(): number | undefined {
    if (this.product) {
      return this.product.price.unitAmount.amount * this.quantity
    }

    if (this.price) {
      return this.price.unitAmount.amount * this.quantity
    }
  }
}
